import React, { useContext } from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import TextItems from 'modules/react/loan-calculator/content/TextItems'
import SkeletonLine from 'modules/react/loan-calculator/content/SkeletonLine'
import Tooltip from 'modules/react/loan-calculator/content/Tooltip'

const LoanTextItem = ({ title, value, tooltip }) => {
  const { loanCalculationObject } = useContext(LoanCalculatorContext)
  const { loanCalculationData, loanCalculationIsLoading } = loanCalculationObject

  return (
    <TextItems.TextItem>
      <TextItems.TextLeft>
        {title}
        <Tooltip content={tooltip}/>
      </TextItems.TextLeft>
      <TextItems.TextRight>
        {!loanCalculationData || loanCalculationIsLoading ? <SkeletonLine/> : value}
      </TextItems.TextRight>
    </TextItems.TextItem>
  )
}

export default LoanTextItem
